import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { formatAsBRL } from '../lib/numbers'

import api from '../services/api'
import Modal from '../components/Modal'
import { getConsumptionById } from '../services/consumption'
import Loading from '../components/Loading'

export default function DesfazerVenda() {
  const params = useParams()
  const [modal, setModal] = useState({})
  const [consumption, setConsumption] = useState({})

  async function desfazerProduto(productId) {
    setModal({
      show: true,
      type: 'warning',
      title: 'Tentando desfazer o produto',
      msg: 'Aguarde...'
    })
    try {
      await api.post(`consumption/undo`, {
        consumptionId: params.creditUsageId,
        productId: productId
      })
      setModal({
        show: true,
        type: 'success',
        title: 'Sucesso',
        msg: 'Produto desfeito com sucesso!'
      })
      setConsumption({
        ...consumption,
        products: consumption.products.map((product) =>
          product._id === productId ? { ...product, isValid: false } : product
        )
      })
    } catch (e) {
      console.log(e.response)
      setModal({
        show: true,
        type: 'danger',
        title: 'Erro',
        msg: JSON.stringify(e.message),
        link: '/'
      })
    }
  }

  function closeModal() {
    setModal({ show: false })
  }

  useEffect(() => {
    onLoad()
  }, [])

  async function onLoad() {
    try {
      getConsumptionById(params.creditUsageId).then((c) => {
        setConsumption(c)
      })
    } catch (e) {
      console.log(e.response)
    }
  }

  if (!consumption.products) {
    return <Loading />
  }
  let total = 0
  return (
    <div className="Venda">
      <Modal modal={modal} />
      {modal.show && (
        <button onClick={closeModal} className="btn btn-secondary btn-sm">
          Fechar
        </button>
      )}
      <h1>Desfazendo venda</h1>
      <div className="lander">
        <p className="text-muted">Escolha os produtos que deseja desfazer:</p>
        <div id="target" className="text-center">
          <h2>Detalhes do Item</h2>
          {consumption.products.map((p) => {
            total += p.price * p.quantity
            return (
              <div
                key={p._id}
                className="product-item"
                style={{
                  textDecoration: p.isValid ? '' : 'line-through',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '10px'
                }}
              >
                <span>
                  {p.quantity} x {p.title}
                </span>
                <span>{formatAsBRL(p.price * p.quantity)}</span>
                <button
                  id={`product-${p.title}`}
                  disabled={!p.isValid}
                  onClick={() => desfazerProduto(p._id)}
                  className="btn btn-danger btn-sm"
                >
                  Desfazer
                </button>
              </div>
            )
          })}
          <h3>{consumption.title}</h3>
          <p>Quantidade: {consumption.quantity}</p>
          <h3>Valor: {total}</h3>
          <p>Lembre que o valor total será adicionado de volta a comanda</p>
          <h2>-- Comanda: {consumption.userTag} --</h2>
          <hr />
        </div>
      </div>
      <div className="text-center">
        <Link to="/bar">
          <button className="btn btn-success btn-lg bt mx-1">Voltar</button>
        </Link>
      </div>
    </div>
  )
}
